import { FormActionButton } from '@workwave-tidal/core/form'

import { useController } from '../../../../hooks/useController'
import { useTexts } from '../../useTexts'

import { form } from '../../../../formState'

export function ReadyFooter() {
  const { status: modalStatus, close } = useController()

  const texts = useTexts()

  const {
    meta: { submitting: formSubmitting, validating },
  } = form.useFormMeta()

  const disabled = validating || formSubmitting || modalStatus === 'submitting'

  return (
    <>
      <FormActionButton
        testId="modal-secondary-button"
        onClick={close}
        size="medium"
        label={texts.cancel}
      />
      <FormActionButton
        testId="modal-primary-button"
        disabled={disabled}
        loading={disabled}
        variant="contained"
        type="submit"
        label={texts.send}
      />
    </>
  )
}
